<question-wrapper [title]="title">
  <div>
    @for (option of options; track option) {
    <div class="ic-options-container">
      <label class="ic-question-option__option">
        <input
          type="radio"
          name="{{ title }}"
          id="{{ option.value }}"
          value="{{ option.value }}"
          class="ic-question-project-radiobutton"
          [(ngModel)]="value"
          (ngModelChange)="onValueChange()"
        />
        <span>{{ option.title }}</span>
      </label>
    </div>
    }
  </div>
</question-wrapper>
